export default __webpack_public_path__ + "static/media/012-dress.1b03f7e3.svg";